import type { MeResponse, OrganizationSummary, UserSummary } from "../../shared/schemas";
import type { ShellViewMode } from "../components/ShellViewModeProvider";

const CONSULTANT_USER_ID = "usr_consultant";

export function isConsultantUser(user: Pick<UserSummary, "id">): boolean {
  return user.id === CONSULTANT_USER_ID;
}

export function resolveShellViewMode(
  user: Pick<UserSummary, "id"> | undefined,
  organization: Pick<OrganizationSummary, "role"> | undefined,
  consultantViewMode: ShellViewMode,
): ShellViewMode {
  if (!user || !organization) return "user";
  if (isConsultantUser(user)) return consultantViewMode;
  return organization.role === "platform_admin" || organization.role === "organization_admin"
    ? "admin"
    : "user";
}

export function resolveShellOrganizationId(
  me: MeResponse | undefined,
  requestedOrganizationId: string | undefined,
): string {
  const firstOrganizationId = me?.organizations[0]?.id ?? "";
  if (!me || !isConsultantUser(me.user)) return firstOrganizationId;

  return me.organizations.some((organization) => organization.id === requestedOrganizationId)
    ? (requestedOrganizationId ?? firstOrganizationId)
    : firstOrganizationId;
}
